/**
 * MagnificPopup.js
 */

import $ from 'jquery';
import magnificPopup from '../../../../../../node_modules/magnific-popup/dist/jquery.magnific-popup.min.js';

class MagnificPopup {

    constructor() {

        $('.image-popup-vertical-fit').magnificPopup({
        	type: 'image',
        	closeOnContentClick: true,
        	mainClass: 'mfp-img-mobile',
            removalDelay: 300,
            mainClass: 'mfp-fade',
        	image: {
        		verticalFit: true
        	},
        	closeMarkup: '<button class="mfp-close"><i class="uo-icon-close icon"></i></button>',
					callbacks: {
						open: function () {
							var originalImageEl = this.currItem.el
							var popupImageEl = this.currItem.img
							if (originalImageEl && popupImageEl) {
								var srcSet = $(originalImageEl).find('img').attr('data-srcset')
								if (srcSet) {
									popupImageEl.attr('srcset', srcSet)
								}
							}
						}
					}
        });


    }

}
new MagnificPopup();
